// @flow
export const MIGRATION_STATUS_REQUEST = 'hive/install-nano1-upgrade/MIGRATION_STATUS_REQUEST';
export const MIGRATION_STATUS_RESPONSE = 'hive/install-nano1-upgrade/MIGRATION_STATUS_RESPONSE';

export const START_MIGRATION_REQUEST = 'hive/install-nano1-upgrade/START_MIGRATION_REQUEST';
export const START_MIGRATION_RESPONSE = 'hive/install-nano1-upgrade/START_MIGRATION_RESPONSE';

export const START_MIGRATION_POLL = 'hive/install-nano1-upgrade/START_MIGRATION_POLL';
export const STOP_MIGRATION_POLL = 'hive/install-nano1-upgrade/STOP_MIGRATION_POLL';

export const PROGRESS_INSTALL_STAGE = 'hive/install-nano1-upgrade/PROGRESS_INSTALL_STAGE';

export const STAGE_BAD_PLACEMENT = 'hive/install-nano1-upgrade/stage/BAD_PLACEMENT';
export const STAGE_CLAIM_HUB = 'hive/install-nano1-upgrade/stage/CLAIM_HUB';
export const STAGE_COMPLETE = 'hive/install-nano1-upgrade/stage/COMPLETE';
export const STAGE_ERROR = 'hive/install-nano1-upgrade/stage/ERROR';
export const STAGE_GOOD_PLACEMENT = 'hive/install-nano1-upgrade/stage/GOOD_PLACEMENT';
export const STAGE_INSTRUCTIONS = 'hive/install-nano1-upgrade/stage/INSTRUCTIONS';
export const STAGE_SLT1_ERROR = 'hive/install-nano1-upgrade/stage/SLT1_ERROR';
export const STAGE_SPARE_ETHERNET = 'hive/install-nano1-upgrade/stage/SPARE_ETHERNET';
export const STAGE_START = 'hive/install-nano1-upgrade/stage/START';
export const STAGE_STATUS = 'hive/install-nano1-upgrade/stage/STATUS';

export const FAILED = 'FAILED';
export const FINISHED = 'FINISHED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const SOURCE_HUB_OFFLINE = 'SOURCE_HUB_OFFLINE';
export const DESTINATION_HUB_OFFLINE = 'DESTINATION_HUB_OFFLINE';
export const DESTINATION_NOT_FOUND = 'DESTINATION_NOT_FOUND';

export const MIGRATION_POLL_INTERVAL = 30000;



// WEBPACK FOOTER //
// ./src/core/state/install-nano1-upgrade/constants.js